; (function () {
    var Global = require('./global');
    
    /**
     * 迅雷客户端接口api
     * @class XlApi
     * @constructor
     */
    var XlApi = {
        /**
         * window.external.GetUserID() <br />
         * 获得userid
         * @method getUserID
         * @return {Number}
         */
        getUserID: function () {
            var userid = '';
            try {
                userid = window.external.GetUserID();
            } catch (e) { }
            return userid;
        },

        /**
         * window.external.GetJumpKey() <br />
         * 获得jumpKey
         * @method getJumpKey
         * @return {Number}
         */
        getJumpKey: function () {
            var jumpKey = '';
            try {
                jumpKey = window.external.GetJumpKey();
            } catch (e) { }
            return jumpKey;
        },

        /**
         * window.external.GetPeerID() <br />
         * 获得peerID
         * @method getPeerID
         * @return {Number}
         */
        getPeerID: function () {
            var peerId = '';
            try {
                peerId = window.external.GetPeerID();
            } catch (e) { }
            return peerId;
        },

        /**
         * window.external.GetSessionID() <br />
         * 获得sessionID
         * @method getSessionID
         * @return {Number}
         */
        getSessionID: function () {
            var sessionId = '';
            try {
                sessionId = window.external.GetSessionID();
            } catch (e) { }
            return sessionId;
        },

        /**
         * window.external.GetSkinID() <br />
         * 获得skinID
         * @method getSkinID
         * @return {Number}
         */
        getSkinID: function () {
            var skinId = '';
            try {
                skinId = window.external.GetSkinID();
            } catch (e) { }
            return skinId;
        },

        /**
         * window.external.GetSkinInfo() <br />
         * 获得skinID
         * @method getSkinInfo
         * @param skinid {string}
         * @return {JSON}
         */
        getSkinInfo: function (skinid) {
            var result;
            try {
                result = JSON.parse(window.external.GetSkinInfo(skinid));

            } catch (e) { }
            return result;
        },

        /**
         * window.external.AttachEvent("OnUserLogin", callback(userid, jumpKey)) <br />
         * 用户登录事件 <br />
         * window.external.AttachEvent("OnUserLogin", FuncOnUserLogin) <br />
         * function FuncOnUserLogin (userid, jumpKey) {} <br />
         * @method userLoginEmit
         */
        userLoginEmit: function (callback) {
            try {
                window.external.AttachEvent("OnUserLogin", function (userid, jumpKey) {
                    typeof callback == 'function' && callback(userid, jumpKey);
                });
            } catch (e) { }
        },

        /**
         * window.external.AttachEvent("OnUserLogout", callback(userid)) <br />
         * 用户登出事件 <br />
         * window.external.AttachEvent("OnUserLogout", FuncOnUserLogout) <br />
         * function FuncOnUserLogout (userid) {} <br />
         * @method userLogoutEmit
         */
        userLogoutEmit: function (callback) {
            try {
                window.external.AttachEvent("OnUserLogout", function (userid) {
                    typeof callback == 'function' && callback(userid);
                });
            } catch (e) { }
        },

        /**
         * window.external.AttachEvent("OnChangeSkin", callback(skinid)) <br />
         * 用户换肤事件 <br />
         * window.external.AttachEvent("OnChangeSkin", FuncOnChangeSkin) <br />
         * function FuncOnChangeSkin (skinid, isVip, skinInfo) {} <br />
         * @method changeSkinEmit
         */
        changeSkinEmit: function (callback) {
            try {
                window.external.AttachEvent("OnChangeSkin", function () {
                    typeof callback == 'function' && callback.apply(null, arguments);
                });
            } catch (e) { }
        },

        /**
         * window.external.ShowLoginDlg() <br />
         * 弹出登入框 <br />
         * @method showLoginDlg
         * @return AlreadyExist : 登录框已经存在导致无法弹出 <br />
         *      IsLoging : 当前处于正在登录状态导致无法弹出 <br />
         *      IsOnline : 当前处于已登录状态导致无法弹出 <br />
         *      undefined: 弹出成功 <br />
         */
        showLoginDlg: function () {
            var result = '';
            try {
                result = window.external.ShowLoginDlg();
            } catch (e) { }
            return result;
        },

        /**
         * window.external.OpenGame(JSON.stringify(opts)) <br />
         * 拉起游戏接口 <br />
         * @method openGame
         * @param opts {object} - 参数: gametype, gameid, serverid, sid <br />
         * serverid, sid 为在哪个服务区
         * @return success {boolean} - 是否成功拉起
         */
        openGame: function (opts) {
            var result = false;
            if (typeof opts === 'object') {
                opts = JSON.stringify(opts);
            }

            try {
                result = window.external.OpenGame(opts);
            } catch (e) { }
            return result;
        },

        /**
         * window.external.LauchFullBox(cmdline) <br />
         * 拉起完整版盒子 <br />
         * @method lauchFullBox
         * @param cmdline {string} - 拉起盒子的命令行参数
         * @return success {boolean} - 是否正常拉起
         */
        lauchFullBox: function (cmdline) {
            var result = false;

            try {
                result = window.external.LauchFullBox(cmdline);
            } catch (e) { }
            return result;
        },

        /**
         * window.external.TrackEvent(key, attr1, attr2, cost1, cost2, cost3, cost4, extData) <br />
         * 埋点统计 <br />
         * @method trackEvent
         * @param key {string} - 统计标识符
         * @param attr1 {string} - 统计attribute1
         * @param attr2 {string} - 统计attribute2
         * @param cost1 {number} - 如有参数extData不可缺省，默认 0
         * @param cost2 {number} - 如有参数extData不可缺省，默认 0
         * @param cost3 {number} - 如有参数extData不可缺省，默认 0
         * @param cost4 {number} - 如有参数extData不可缺省，默认 0
         * @param extData {string}
         */
        trackEvent: function (key, attr1, attr2, cost1, cost2, cost3, cost4, extData) {
            var result = false;
            if (Global.clientVersion === 'unknow') {
                return result;
            }
            
            var opts = {};
            var defaultOpts = {
                key: '',
                attr1: '',
                attr2: '',
                cost1: 0,
                cost2: 0,
                cost3: 0,
                cost4: 0,
                extData: ''
            };
            // 传一个 object 对象
            if (arguments.length == 1 && typeof arguments[0] == 'object') {
                opts = _.extend(defaultOpts, arguments[0]);
            } else {
            // 普通参数
                if (typeof key === 'undefined') {
                    return result;
                }
                if (typeof key !== 'undefined') {
                    opts.key = key;
                }
                if (typeof attr1 !== 'undefined') {
                    opts.attr1 = attr1;
                }
                if (typeof attr2 !== 'undefined') {
                    opts.attr2 = attr2;
                }
                if (typeof cost1 !== 'undefined') {
                    opts.cost1 = cost1;
                }
                if (typeof cost2 !== 'undefined') {
                    opts.cost2 = cost2;
                }
                if (typeof cost3 !== 'undefined') {
                    opts.cost3 = cost3;
                }
                if (typeof cost4 !== 'undefined') {
                    opts.cost4 = cost4;
                }
                if (typeof extData !== 'undefined') {
                    opts.extData = extData;
                }
                opts = _.extend(defaultOpts, opts);
            }
            
            // 强制转换字符串
            if (typeof opts.attr1 !== 'string') {
                opts.attr1 = String(opts.attr1);
            }
            if (typeof opts.attr2 !== 'string') {
                opts.attr2 = String(opts.attr2);
            }
            if (typeof opts.attribute1 !== 'string') {
                opts.attribute1 = String(opts.attribute1);
            }
            if (typeof opts.attribute2 !== 'string') {
                opts.attribute2 = String(opts.attribute2);
            }
            // 迅雷7 的参数处理
            if (Global.isPcXunlei7) {
                opts = XlApi._parametersHandler(opts);
            }
            
            try {
                result = window.external.TrackEvent(opts.key, opts.attr1 || opts.attribute1, opts.attr2 || opts.attribute2, opts.cost1, opts.cost2, opts.cost3, opts.cost4, opts.extData);
            } catch (e) { }
            return result;
        },
        
        /** 
         * 迅雷7 的参数为 value1, value2, value3
         * 如果版本是迅雷7 
         * 需将attr2, cost1, cost2, cost3, cost4, 
         * 以attr2=... cost1=... cost2=... cost3=... cost4=... 的形式放入extData中
         */ 
        _parametersHandler: function (opts) {
            if (typeof opts !== 'object') {
                return opts;
            }
            
            var array = [];
            if (opts.extData !== '') {
                array.push(opts.extData);
            }
            if (opts.attr2 !== '') {
                array.push('attr2=' + opts.attr2);
                opts.attr2 = '';
            }
            if (opts.cost1 !== 0) {
                array.push('cost1=' + opts.cost1);
                opts.cost1 = 0;
            }
            if (opts.cost2 !== 0) {
                array.push('cost2=' + opts.cost2);
                opts.cost2 = 0;
            }
            if (opts.cost3 !== 0) {
                array.push('cost3=' + opts.cost3);
                opts.cost3 = 0;
            }
            if (opts.cost4 !== 0) {
                array.push('cost4=' + opts.cost4);
                opts.cost4 = 0;
            }
            opts.extData = array.join(',');
            return opts;
        },

        /**
         * window.external.OpenNewTab(url, bSelected, context, bMainTab) <br />
         * 打开客户端新窗口 <br />
         * @method openNewTab
         */
        openNewTab: function (url, bSelected, context, bMainTab) {
            var tabId = '';
            try {
                tabId = window.external.OpenNewTab(url, bSelected, context, bMainTab);
            } catch (e) {
                window.open(url, context);
             }
            return tabId;
        },

        /**
         * window.external.SelectTab(tabId) <br />
         * 切换至客户端指定窗口 <br />
         * @method selectTab
         */
        selectTab: function (tabId) {
            try {
                window.external.SelectTab(tabId);
            } catch (e) { }
        },

        /**
         * window.external.IsTabExist(tabId) <br />
         * 判断客户端窗口是否存在 <br />
         * @method isTabExist
         */
        isTabExist: function (tabId) {
            var exist = false;
            try {
                exist = window.external.IsTabExist(tabId);
            } catch (e) { }
            return exist;
        },

        /**
         * window.external.GetTabIDByContext(context) <br />
         * 根据context获得客户端窗口ID <br />
         * @method getTabByContext
         */
        getTabIdByContext: function (context) {
            var tabId = '';
            try {
                tabId = window.external.GetTabIDByContext(context);
            } catch (e) { }
            return tabId;
        },

        /**
         * window.external.GetLocalXMPHistory() <br />
         * 获得xmp历史记录本地文件数据 <br />
         * @method getLocalXMPHistory
         */
        getLocalXMPHistory: function () {
            var result = null;
            try {
                result = window.external.GetLocalXMPHistory();
            } catch (e) { }
            return result;
        },

        /**
         * window.external.ShowVipMiniPage() <br />
         * 拉起迅雷vip迷你页 <br />
         * @method showVipMiniPage
         */
        showVipMiniPage: function () {
            try {
                window.external.ShowVipMiniPage('lixian');
            } catch (e) { }
        },

        /**
         * window.external.XMPPlayByPlayUrl(splayUrl, scid, sname) <br />
         * 由url拉起xmp播放器 <br />
         * @method xmpPlayByPlayUrl
         */
        xmpPlayByPlayUrl: function (splayUrl, scid, sname) {
            try {
                window.external.XMPPlayByPlayUrl(splayUrl, scid, sname);
            } catch (e) { }
        },

        /**
         * window.external.XMPPlayByMovieID(imovieid, isubmovieid, sname, ssource, stype, ssourcename) <br />
         * 由movieID拉起xmp播放器 <br />
         * @method xmpPlayByPlayUrl
         */
        xmpPlayByMovieID: function (imovieid, isubmovieid, sname, ssource, stype, ssourcename) {
            try {
                window.external.XMPPlayByMovieID(imovieid, isubmovieid, sname, ssource, stype, ssourcename);
            } catch (e) { }
        },

        /**
         * window.external.IsMainPageFirstShow() <br />
         * 安装后是否第一次打开迅雷9 <br />
         * @method isMainPageFirstShow
         * @return boolean
         */
        isMainPageFirstShow: function () {
            var result = false;
            try {
                result = window.external.IsMainPageFirstShow();
            } catch (e) { }
            return result;
        },

        /**
         * window.external.GetThunderVersion() <br />
         * 获得迅雷客户端版本号，目前该方法只注册于迅雷9 <br />
         * @method getThunderVersion
         */
        getThunderVersion: function () {
            var result = 'unknow';
            try {
                result = window.external.GetThunderVersion();
            } catch (e) { }
            return result;
        },
        
        /**
         * window.external.getBrowserHistory() <br />
         * 获得迅雷客户端浏览历史记录
         * @method getBrowserHistory
         * @return objectString 
         * objectString = {count: number, history: array[list1, list2...]}
         * list1 {
         *     count: 访问次数
         *     host: 
         *     icon_path: icon路径 (本地host + 端口号 + icon路径)
         *     image_path: 缩略图路径 (本地host + 端口号 + 缩略图路径)
         *     image_time: 
         *     title: 网站标题
         * }
         */
        getBrowserHistory: function (num) {
            // 默认值
            var result = JSON.stringify({count: 0, history: []});
            var version = Global.clientVersion || (version = XlApi.getThunderVersion());
            if (version === 'unknow') {
                return result;
            }
            
            try {
                result = window.external.GetDataList(num);
            } catch (e) {}
            return result;
        },
        
        /**
         * window.external.deleteBrowserHistory() <br />
         * 删除迅雷客户端浏览历史记录
         * @method getBrowserHistory
         * @param host 要删除历史记录的host
         * @return boolean 
         */
        deleteBrowserHistory: function (host) {
            var result = false;
            try {
                result = window.external.DeleteOneImageInfo(host);
            } catch (e) {}
            return result;
        },
        
        /**
         * window.external.NiuX_GetNavigationMsg()
         * 获取首页导航栏消息下拉提示信息
         * @return result {string} - json类型的字符串，格式如下： 
         * '{"context":"这是第一条素材","onclick":{"clientinfo":{"client_param":"","client_url":"","client_url@":{"md5":""}},"gameboxinfo":{"param":""},"opentype":"2","openurl":"http://jump.niu.xunlei.com:8080/zuyEZz"},"showtimer":"10","iconurl":"http://xxx"}' 
         * 考虑以后数据字段拓展，把后台配置内容透传过来的，按需提取所需字段即可；下拉提示的文本取context字段，图标链接取iconurl字段；
         */
        niuX_GetNavigationMsg: function() {
            var result = '{}';
            try {
                result = window.external.NiuX_GetNavigationMsg();
            } catch (e) {};
            // console.log('niuX_GetNavigationMsg ------ ' + result);
            return result || '{}';
        },

        /**
         * window.external.NiuX_OnNavigationMsgClick()
         * 功能：响应首页导航栏消息下拉提示的点击操作
         * @return suc {boolean} - false表示内部数据错误，内部未曾记录过当前弹出信息或者记录不在缓存数据内，理论上不存在失败
         */
        niuX_OnNavigationMsgClick: function() {
            var result = false;
            try {
                result = window.external.NiuX_OnNavigationMsgClick();
            } catch (e) {};
            return result;
        },
        
        /**
         * 获取迅雷9配置文件的值
         * @method getConfigValue
         * @param superKey - 主键
         * @param subKey - 扩展键
         * @param defaultValue - 默认配置一个返回值，如果获取不到值则返回它
         */
        getConfigValue: function (superKey, subKey, defaultValue) {
            var result = '';
            try {
                result = window.external.GetConfigValue(superKey, subKey, defaultValue);
            } catch (e) {};
            return result;
        }
    };

    if (typeof exports === 'object') {
        module.exports = XlApi;
    }
})();



//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/xl_api.js
// module id = 2
// module chunks = 1 2 3 5 6 7 8 9 10 11 12